import $ from "jquery";
import debug from "bows";

const log = debug('home-slider');
const $nhs = $('.ne-hero-slick');

function initialize_slides() {
	$nhs.slick({
		dots: false,
		infinite: true,
		speed: 500,
		slidesToScroll: 1,
		slidesToShow: 1,
		//fade: true,
		cssEase: 'ease',
		// autoplay: true,
		arrows: false,
		adaptiveHeight: true
	});

	$('.ne-meta__btn--prev').on('click', function () {
		$nhs.slick('slickPrev');
	});
	$('.ne-meta__btn--next').on('click', function () {
		$nhs.slick('slickNext');
	});
}

export function init() {
	if ($nhs.length) {
		initialize_slides();
	}
}

export default {
	init
};
